import React from 'react'

import Link from 'next/link'

import * as S from './styles'
import { useGlassdoor } from './useGlassdoor'
import { StarIcon } from '@/assets/icons'
import { Image, Text } from '@/components'
import { Button } from '@/components/button'
import { useIsVisibleElement } from '@/hooks'
import { Glassdoor } from '@/service/api/home'

type GlassdoorContainerProps = {
  /**
   * The data of the glassdoor
   *
   * @example
   * ```tsx
   * const data = {
   *  ...
   * }
   *
   * <GlassdoorContainer glassdoorData={data} />
   * ```
   */
  glassdoorData: Glassdoor
}

export const GlassdoorContainer: React.FC<GlassdoorContainerProps> = ({
  glassdoorData,
}) => {
  const { fontSizes, separateStars } = useGlassdoor()
  const starsScoresArray = separateStars(glassdoorData.score)

  const { element, elementVisible } = useIsVisibleElement()

  if (!glassdoorData.title) return null
  return (
    <S.GlassDoorContainer>
      <S.GlassdoorTextContainer>
        <Text
          size={fontSizes.glassdoorTitle}
          color="white"
          className="glassdoor-title"
        >
          {glassdoorData.title}
        </Text>
        <Text
          size={fontSizes.glassdoorDescription}
          className="glassdoor-description"
          color="white"
        >
          {glassdoorData.description}
        </Text>
        <div className="score-button-container">
          <S.GlassdoorReviewContainer>
            <Text
              size={fontSizes.glassdoor}
              color="green"
              className="glassdoor"
            >
              glassdoor
            </Text>
            <Text
              size={fontSizes.glassdoorScore}
              color="green"
              className="glassdoor-score"
            >
              {glassdoorData.score}
            </Text>
            <S.StarContainer filledPercent={starsScoresArray[0]}>
              <Image
                src={StarIcon}
                alt="Ícone de estrela"
                defaultSize={{ height: 20, width: 20 }}
                responsiveSizes={{
                  1424: { width: 18, height: 18 },
                  742: { width: 17, height: 17 },
                }}
              />
            </S.StarContainer>
            <S.StarContainer filledPercent={starsScoresArray[1]}>
              <Image
                src={StarIcon}
                alt="Ícone de estrela"
                defaultSize={{ height: 20, width: 20 }}
                responsiveSizes={{
                  1424: { width: 18, height: 18 },
                  742: { width: 17, height: 17 },
                }}
              />
            </S.StarContainer>
            <S.StarContainer filledPercent={starsScoresArray[2]}>
              <Image
                src={StarIcon}
                alt="Ícone de estrela"
                defaultSize={{ height: 20, width: 20 }}
                responsiveSizes={{
                  1424: { width: 18, height: 18 },
                  742: { width: 17, height: 17 },
                }}
              />
            </S.StarContainer>
            <S.StarContainer filledPercent={starsScoresArray[3]}>
              <Image
                src={StarIcon}
                alt="Ícone de estrela"
                defaultSize={{ height: 20, width: 20 }}
                responsiveSizes={{
                  1424: { width: 18, height: 18 },
                  742: { width: 17, height: 17 },
                }}
              />
            </S.StarContainer>
            <S.StarContainer filledPercent={starsScoresArray[4]}>
              <Image
                src={StarIcon}
                alt="Ícone de estrela"
                defaultSize={{ height: 20, width: 20 }}
                responsiveSizes={{
                  1424: { width: 18, height: 18 },
                  742: { width: 17, height: 17 },
                }}
              />
            </S.StarContainer>
          </S.GlassdoorReviewContainer>
          <Link href="/culture" passHref>
            <Button>{glassdoorData.buttonText}</Button>
          </Link>
        </div>
      </S.GlassdoorTextContainer>
      <div ref={element} className="container-img">
        <Image
          src={glassdoorData.image.src}
          alt={glassdoorData.image.alt}
          fileName={glassdoorData.image.fileName}
          className="nata-image-blur"
        />
        <Image
          src={glassdoorData.image.src}
          alt={glassdoorData.image.alt}
          fileName={glassdoorData.image.fileName}
          className={`nata-image ${elementVisible ? 'active' : ''}`}
          defaultSize={{ height: 625, width: 669 }}
          responsiveSizes={{
            500: { width: 358, height: 190 },
            668: { width: 500, height: 440 },
          }}
        />
      </div>
    </S.GlassDoorContainer>
  )
}
